import axios from 'axios'

const baseURL = `${process.env.GATSBY_NETLIFY_API_URL}/reviews`

export const getReviewsByProduct = async (external_id, page) => {
  const { data } = await axios.get(baseURL, {
    params: {
      page,
      external_id,
    },
  })

  return data
}

export const addReviewToProduct = async (payload) => {
  const { data } = await axios.post(baseURL, payload)

  return data
}
